function Skills() {
    return (
      <section id="skills" className="section">
        <h2>Skills</h2>
  
        <div className="skills-category">
          <h3>Frontend</h3>
          <div className="skills-list">
            <span>HTML</span>
            <span>CSS</span>
            <span>JavaScript</span>
            <span>React</span>
          </div>
        </div>
  
        <div className="skills-category">
          <h3>DevOps & Tools</h3>
          <div className="skills-list">
            <span>Git</span>
            <span>GitHub</span>
            <span>Linux</span>
            <span>Docker</span>
            <span>npm</span>
          </div>
        </div>
  
        <div className="skills-category">
          <h3>Cloud & Networking</h3>
          <div className="skills-list">
            <span>Azure</span>
            <span>AWS Basics</span>
            <span>Networking Basics</span>
            <span>System Administration Basics</span>
          </div>
        </div>
      </section>
    );
  }
  
  export default Skills;